import React, {useState} from 'react';
import Button from "../../../../bootstrap/components/button/Button";
import ConfirmDialog from "../../../../bootstrap/components/confirm-dialog/ConfirmDialog";


export default function DeleteButton({title, handleDelete}) {

    const [confirm, setConfirm] = useState(false);

    return <>
        <Button
            title={title}
            appearance="solid-danger"
            onClick={() => {
                setConfirm(true);
            }}
        />
        {
            confirm &&
            <ConfirmDialog
                confirm={() => {
                    handleDelete();
                }}
                cancel={() => {
                    setConfirm(false);
                }}
            />
        }
    </>;
}
